console.log("application.js loading...")
import "@hotwired/turbo-rails"
import { Application } from "@hotwired/stimulus"

console.log("Stimulus imported, starting application...")
const application = Application.start()
console.log("Stimulus application started")

// Import controllers
import FlashController from "./controllers/flash_controller"
import DropdownController from "./controllers/dropdown_controller"
import WebhookTesterController from "./controllers/webhook_tester_controller"
import SlackMessageBuilderController from "./controllers/slack_message_builder_controller"
import OutletFlowEditorController from "./controllers/outlet_flow_editor_controller"
import BlockFlowPreviewController from "./controllers/block_flow_preview_controller"
import ConnectionTestController from "./controllers/connection_test_controller"
import ConnectionVerifyController from "./controllers/connection_verify_controller"
import FlowCanvasController from "./controllers/flow_canvas_controller"
import SlackListenerFormController from "./controllers/slack_listener_form_controller"
import AgentFormController from "./controllers/agent_form_controller"
import TriggerActionController from "./controllers/trigger_action_controller"
import TriggerAdderController from "./controllers/trigger_adder_controller"
import NotificationsController from "./controllers/notifications_controller"
import ToastController from "./controllers/toast_controller"
import CollapsibleJsonController from "./controllers/collapsible_json_controller"
import ToggleController from "./controllers/toggle_controller"
import ThemeController from "./controllers/theme_controller"
import ActionPreviewController from "./controllers/action_preview_controller"
import DetailModalController from "./controllers/detail_modal_controller"
import ExecutionsListController from "./controllers/executions_list_controller"
import ConnectWizardController from "./controllers/connect_wizard_controller"
import NotificationPrefsController from "./controllers/notification_prefs_controller"

application.register("flash", FlashController)
application.register("dropdown", DropdownController)
application.register("webhook-tester", WebhookTesterController)
application.register("slack-message-builder", SlackMessageBuilderController)
application.register("outlet-flow-editor", OutletFlowEditorController)
application.register("block-flow-preview", BlockFlowPreviewController)
application.register("connection-test", ConnectionTestController)
application.register("connection-verify", ConnectionVerifyController)
application.register("flow-canvas", FlowCanvasController)
application.register("slack-listener-form", SlackListenerFormController)
application.register("agent-form", AgentFormController)
application.register("trigger-action", TriggerActionController)
application.register("trigger-adder", TriggerAdderController)
application.register("notifications", NotificationsController)
application.register("toast", ToastController)
application.register("collapsible-json", CollapsibleJsonController)
application.register("toggle", ToggleController)
application.register("theme", ThemeController)
application.register("action-preview", ActionPreviewController)
application.register("detail-modal", DetailModalController)
application.register("executions-list", ExecutionsListController)
application.register("connect-wizard", ConnectWizardController)
application.register("notification-prefs", NotificationPrefsController)

// Make Stimulus available for debugging
window.Stimulus = application
